/**
 * UTF-16 Big Endian Encoding.
 *
 * @group Utils
 *
 * @beta
 */
export const UTF_16_BE = 'utf-16be';
//# sourceMappingURL=UTF_16_BE.js.map